// extracted by mini-css-extract-plugin
export var container = "color_change-module--container--bIRK+";
export var img = "color_change-module--img--IL9Ix";
export var text = "color_change-module--text--IEBDw";